import React, {useState, useRef} from 'react';
import validateEmail from '../utils/validateEmail.js';
import validateRestorePassword from '../utils/validateRestorePassword.js';
import FormText from '../components/FormText.js';
import FormScan from '../components/FormScan.js';
import post from '../utils/post.js';
import {Link} from 'react-router-dom';

export default function Register() {
	const [username, setUsername] = useState('');
	const [firstName, setFirstName] = useState('');
	const [lastName, setLastName] = useState('');
	const [nickname, setNickname] = useState('');
	const [phone, setPhone] = useState('');
	const [prefix, setPrefix] = useState('420');
	const [password, setPassword] = useState('');
	const [password2, setPassword2] = useState('');
	const [usernameError, setUsernameError] = useState('');
	const [firstNameError, setFirstNameError] = useState('');
	const [lastNameError, setLastNameError] = useState('');
	const [nicknameError, setNicknameError] = useState('');
	const [phoneError, setPhoneError] = useState('');
	const [prefixError, setPrefixError] = useState('');
	const [passwordError, setPasswordError] = useState('');
	const [passwordError2, setPasswordError2] = useState('');
	const [loading, setLoading] = useState(false);
	const [result, setResult] = useState('');
	const [result2, setResult2] = useState(0);
	const [parentPromoCode, setParentPromoCode] = useState('');
	const [parentPromoCodeError, setParentPromoCodeError] = useState('');

	const usernameRef = useRef();
	const firstNameRef = useRef();
	const lastNameRef = useRef();
	const nicknameRef = useRef();
	const phoneRef = useRef();
	const prefixRef = useRef();
	const passwordRef = useRef();
	const passwordRef2 = useRef();
	const parentPromoCodeRef = useRef();

	const handleSubmit = (e) => {
		e.preventDefault();

		setUsernameError('');
		setFirstNameError('');
		setLastNameError('');
		setNicknameError('');
		setPhoneError('');
		setPrefixError('');
		setPasswordError('');
		setPasswordError2('');
		setParentPromoCodeError('');

		let localError = 0;

		if (!username) {
			localError = 1;
			setUsernameError('povinné');
			usernameRef.current.focus();
		} else if (!validateEmail(username)) {
			localError = 1;
			setUsernameError('Neplatný email');
			usernameRef.current.focus();
		}

		if (!firstName) {
			if (localError === 0) {
				firstNameRef.current.focus();
			}
			localError = 1;
			setFirstNameError('povinné');
		}

		if (!lastName) {
			if (localError === 0) {
				lastNameRef.current.focus();
			}
			localError = 1;
			setLastNameError('povinné');
		}

		if (!prefix) {
			if (localError === 0) {
				prefixRef.current.focus();
			}
			localError = 1;
			setPrefixError('*');
		}

		if (!phone || phone.length < 9) {
			if (localError === 0) {
				phoneRef.current.focus();
			}
			localError = 1;
			setPhoneError('*');
		}

		const sError = validateRestorePassword(password, password2);
		setPasswordError(sError.password);
		setPasswordError2(sError.password2);

		if (sError.password !== '') {
			if (localError === 0) {
				passwordRef.current.focus();
			}
			localError = 1;
		}

		if (sError.password2 !== '') {
			if (localError === 0) {
				passwordRef2.current.focus();
			}
			localError = 1;
		}

		if (localError === 0) {
			setLoading(true);

			post('register', {username, firstName, lastName, nickname, phone, prefix, password, parentPromoCode})
				.then((res) => {
					if (res.data === -1) {
						setResult('Došlo k neznámé chybě. Zkuste to později.');
					} else if (res.data === 0) {
						setResult('Tento email je už registrovaný. Zkuste jiný.');
					} else if (res.data === 1) {
						setResult2(1);
					}

					setLoading(false);
				})
				.catch((error) => {
					console.error(error);
					setLoading(false);
				});
		}
	};

	const handleVerifyPromo = (e) => {
		e.preventDefault();

		setParentPromoCodeError('');

		if (parentPromoCode !== '') {
			setLoading(true);

			post('verifyPromoCode', {parentPromoCode})
				.then((res) => {
					if (res.data.result === -1) {
						setParentPromoCodeError('Došlo k neznámé chybě. Zkuste to později.');
					} else if (res.data.result === 0) {
						setParentPromoCodeError('Neplatná pozvánka.');
					} else if (res.data.result === 1) {
						setParentPromoCodeError(res.data.resultTxt);
					}

					setLoading(false);
				})
				.catch((error) => {
					console.error(error);
					setLoading(false);
				});
		} else {
			setParentPromoCodeError('Zadejte pozvánku.');
			parentPromoCodeRef.current.focus();
		}
	}

	return (
		<div className="login">
			{loading ? <div className="loading" /> : ''}

			<div className="login_shell">
				<div className="login_brand">
					<img className="login_logo" alt="" />
				</div>

				<div className="login_container auth-card auth-card--wide">
					<div className="login_container_in auth-card__body">
						<h1 className="auth-card__title">Registrace</h1>
						<p className="auth-card__text">Vytvoř si účet, doplň základní údaje a případně ověř pozvánku od kamaráda.</p>

						{result2 === 0 ? (
							<form method="POST" onSubmit={handleSubmit} className="auth-form auth-form--wide">
								<div className="auth-form__field auth-form__field--full">
									<FormText type="text" label="Email" value={username} setValue={setUsername} ref={usernameRef} error={usernameError} />
								</div>
								<div className="auth-form__field auth-form__field--half">
									<FormText type="text" label="Jméno" value={firstName} setValue={setFirstName} ref={firstNameRef} error={firstNameError} />
								</div>
								<div className="auth-form__field auth-form__field--half">
									<FormText type="text" label="Příjmení" value={lastName} setValue={setLastName} ref={lastNameRef} error={lastNameError} />
								</div>
								<div className="auth-form__field auth-form__field--half">
									<FormText type="text" label="Přezdívka" value={nickname} setValue={setNickname} ref={nicknameRef} error={nicknameError} />
								</div>
								<div className="auth-form__field auth-form__field--half auth-form__field--phone-group">
									<div className="auth-form__row auth-form__row--phone">
										<div className="auth-form__subfield auth-form__subfield--phone-prefix">
											<FormText type="text" label="Předv." value={prefix} placeholder="420" maxLength="3" setValue={setPrefix} ref={prefixRef} error={prefixError} />
										</div>
										<div className="auth-form__subfield auth-form__subfield--phone-number">
											<FormText type="text" label="Telefon" placeholder="111222333" maxLength="9" value={phone} setValue={setPhone} ref={phoneRef} error={phoneError} />
										</div>
									</div>
								</div>
								<div className="auth-form__field auth-form__field--half">
									<FormText type="password" label="Heslo" value={password} setValue={setPassword} ref={passwordRef} error={passwordError} />
								</div>
								<div className="auth-form__field auth-form__field--half">
									<FormText type="password" label="Znovu hesla" value={password2} setValue={setPassword2} ref={passwordRef2} error={passwordError2} />
								</div>
								<div className="auth-form__field auth-form__field--full auth-form__field--promo-row">
									<div className="auth-form__row auth-form__row--promo">
										<div className="auth-form__field auth-form__field--promo-input">
											<FormScan type="text" label="Pozvánka od kamaráda" value={parentPromoCode} setValue={setParentPromoCode} ref={parentPromoCodeRef} error={parentPromoCodeError} />
										</div>
										<div className="auth-form__field auth-form__field--promo-action">
											<input type="button" name="button_verify" value="Ověřit" className="button auth-pill-button auth-pill-button--secondary auth-pill-button--inline" disabled={loading} onClick={handleVerifyPromo} />
										</div>
									</div>
								</div>
								<div className="auth-form__actions auth-form__actions--wide">
									<input type="submit" name="button_login" value="Registrovat" className="button auth-pill-button" disabled={loading} />
								</div>
								{result !== '' ? <div className="login_result auth-result">{result}</div> : ''}
							</form>
						) : (
							<div className="auth-message auth-message--success">Registrace proběhla úspěšně. Na zadanou emailovou adresu byl zaslán odkaz na aktivaci účtu. Po aktivaci bude možné se přihlásit.</div>
						)}

						<div className="auth-links auth-links--center">
							<Link to={'/'} key="lnk_login" className="lnk1 auth-link">
								Zpět na úvodní stránku
							</Link>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}
